/* ============
 * Vue Breadcrumbs
 * ============
 *
 * Vue breadcrumbs builds on the official vue-router package to provide simple breadcrumbs.
 *
 * https://github.com/samturrell/vue-breadcrumbs
 */

import Vue from 'vue'

function install (Vue, options) {
  // Add the $breadcrumbs property to the Vue instance
  Object.defineProperty(Vue.prototype, '$breadcrumbs', {
    get: function get () {
      var crumbs = []

      var matched = this.$route.matched

      matched.forEach(function (route) {
        // Backwards compatibility
        var hasBreadcrumb = (parseFloat(Vue.version) < 2)
          ? route.handler && route.handler.breadcrumb
          : route.meta && route.meta.breadcrumb && route.name

        if (hasBreadcrumb) {
          crumbs.push(route)
        }
      })

      return crumbs
    }
  })

  var defaults = {
    methods: {
      // Return the correct prop data
      linkProp: function (crumb) {
        // If it's a named route, we'll base the route
        // off of that instead
        if (crumb.name || (crumb.handler && crumb.handler.name)) {
          return {
            name: crumb.name || crumb.handler.name,
            params: this.$route.params
          }
        }

        return {
          path: (crumb.handler && crumb.handler.fullPath)
            ? crumb.handler.fullPath
            : crumb.path,
          params: this.$route.params
        }
      }
    },

    filters: {
      // Display the correct breadcrumb text
      // depending on the Vue version
      crumbText: function (crumb) {
        return (parseFloat(Vue.version) < 2) ? crumb.handler.breadcrumb : crumb.meta.breadcrumb
      }
    },

    template: '<nav class="breadcrumbs" v-if="$breadcrumbs.length"> ' +
    '<ul> ' +
    '<li v-for="crumb in $breadcrumbs"> ' +
    '<router-link :to="linkProp(crumb)">{{ crumb | crumbText }}</router-link> ' +
    '</li> ' +
    '</ul> ' +
    '</nav>'
  }

  // Add a default breadcrumbs component
  Vue.component('breadcrumbs', Object.assign(defaults, options))
}

const breadcrumbs = {
  install: install,
  version: '0.3.1'
}

Vue.use(breadcrumbs, {
  template: '<ul class="page-breadcrumb" v-if="$breadcrumbs.length">' +
  ' <li v-for="(crumb, key) in $breadcrumbs" :key="key"><router-link class="breadcrumb-item" :to="linkProp(crumb)">{{ crumb | crumbText }}</router-link>' +
  ' <i class="fa fa-circle" v-if="key !== $breadcrumbs.length - 1"></i></li></ul>'
})



// WEBPACK FOOTER //
// ./src/app/plugins/vue-breadcrumbs.js